import moment from "moment";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  Link,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CustomChip from "../../common/customChip/CustomChip";
import DataCell from "./DataCell";
import styles from "./styles.module.scss";
import CustomButton from "components/CustomButton";
import { ReactComponent as ActiveControl } from "assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "assets/img/svg/InactiveControl.svg";
import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";
import { EyeIcon } from "../../unAssigned/studentCharges/common";

import commonStyles from "../common/commonStyles.module.css";
import { ReactComponent as CopyIcon } from "../../../../../assets/img/svg/CopyClipboardIcon.svg";
import TestStatusChangeConfirmationDialog from "./TestStatusChangeConfirmationDialog";
import APopover from "../../common/a-popover";
import TestForm from "../academicTest/TestForm";
import AttachTestForm from "./AttachTestForm";
import { getTestMediumDisplayValue } from "./constant";
import DeleteConfirmationPopup from "./DeleteConfirmationPopup";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import TestSyllabus from "./TestSyllabus";

export const getDateFormateDate = (date) => {
  if (moment(date).isValid()) {
    return new moment(date).format("DD/MM/YYYY");
  }
  return "-";
};

export const getTimeFormated = (date) => {
  if (moment(date).isValid()) {
    return new moment(date).format("hh:mm A");
  }
  return "-";
};

const TestCard = ({
  planData,
  testData,
  index,
  expandedIndex,
  setExpandedIndex,
  initialiseList,
  updateTestStatusHandler = () => {},
  updateAttachTestHandler = () => {},
  deleteImportedTest = () => {},
  ...props
}) => {
  const [toolTipText, setToolTipText] = useState("Copy");
  const containerClass = props?.isImportedTest
    ? styles.imported_test_card_data_container
    : styles.test_card_data_container;

  const [openDialog, setOpenDialog] = useState(false);

  const closeDeleteDialogValue = {
    open: false,
    testId: "",
  };
  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(
    closeDeleteDialogValue
  );

  const isIncomplete =
    testData?.startDate &&
    testData?.endDate &&
    testData?.resultDate &&
    testData?.mode &&
    testData?.format;

  const isPastDate = (date) => {
    if (!moment(date).isValid()) {
      return false;
    }
    return new Date(date) < new Date().setHours(0, 0, 0, 0);
  };

  const activeInactiveHandler = () => {
    if (props?.isImportedTest) return false;

    if (isIncomplete) setOpenDialog(true);
  };

  // used for caching the response
  // const [isSyllabusFetched, setIsSyllabusFetched] = useState(false);
  // const [testSyllabus, setTestSyllabus] = useState([]);

  // for update form
  const [isFormOpen, setIsFormOpen] = useState(false);
  const testBasicDetails = {
    ...testData,
    testType: { label: testData?.testType, value: testData?.testType },
    isMandatory: testData?.isMandatory,
    format: { label: testData?.format, value: testData?.format },
    mode: { label: testData?.mode, value: testData?.mode },
    testNumber: "",
    startDate: testData?.startDate,
    endDate: testData?.endDate,
    resultDate: testData?.resultDate,
    testStartTime:
      !testData.isTimeTableTest &&
      !testData?.isStartWithinTimeRequired &&
      testData?.mode !== "Offline"
        ? {
            label: getTimeFormated(
              testData?.testStartTime || testData?.startDate
            ),
            value: moment(
              testData?.testStartTime || testData?.startDate
            ).format("HH"),
          }
        : new Date(testData?.startDate),
    testEndTime:
      !testData.isTimeTableTest &&
      !testData?.isStartWithinTimeRequired &&
      testData?.mode !== "Offline"
        ? {
            label: getTimeFormated(testData?.testEndTime || testData?.endDate),
            value: moment(testData?.testEndTime || testData?.endDate).format(
              "HH"
            ),
          }
        : new Date(testData?.endDate),
    resultTime: testData?.resultDate,
    isStartWithin: testData?.isStartWithinTimeRequired,
    startWithinTime: testData?.startWithinTimePeriod,
  };

  const handleDeleteTest = () => {
    deleteImportedTest(openDeleteConfirmDialog.testId);
    setOpenDeleteConfirmDialog(closeDeleteDialogValue);
  };

  return (
    <>
      <Card className="mb-2">
        <CardBody className="p-3">
          <div className="d-flex justify-content-xl-between mb-2">
            <div className="d-flex">
              <h3 style={{ fontSize: "20px" }}>
                {testData?.testType}{" "}
                {testData?.testNameNew ? ` - ${testData?.testNameNew}` : ""}
              </h3>
              <CustomChip
                // text={}
                textColor="#006A93"
                bgColor={"#CCEFFD"}
                style={{ marginLeft: "1rem" }}
              >
                <div>
                  {testData?.testName || "Name not found"}
                  <Tooltip title={toolTipText}>
                    <span style={{ marginLeft: "5px" }}>
                      <CopyIcon
                        onClick={() => {
                          navigator.clipboard.writeText(testData?.testName);
                          setToolTipText("Copied");
                        }}
                      />
                    </span>
                  </Tooltip>
                </div>
              </CustomChip>
              <CustomChip
                text={
                  testData?.isMandatory ? "Mandatory test" : "Optional test"
                }
                textColor="#006A93"
                bgColor={"#CCEFFD"}
                style={{ marginLeft: "1rem" }}
              />

              {testData?.isAlreadyImported && (
                <CustomChip
                  text="This test is already imported in this Academic plan"
                  textColor={"#333333"}
                  bgColor={"#FFEDC8"}
                  style={{ marginLeft: "1rem" }}
                />
              )}
            </div>

            <div className="d-flex align-items-center ml-auto">
              {testData?.isImportedTest && (
                <div className="d-flex align-items-center justify-content-between">
                  <CustomButton
                    content={""}
                    permissionType={"D"}
                    icon={true}
                    forTable={true}
                    onClick={() => {
                      setOpenDeleteConfirmDialog({
                        open: true,
                        testId: testData.id,
                      });
                    }}
                    permissionSet={props.userPermissions}
                  />

                  <span className="semi-bold color-dark ml-2">
                    Imported test
                  </span>
                </div>
              )}
              {!isIncomplete && (
                <CustomChip
                  className="ml-2"
                  text={"Incomplete details"}
                  textColor={"#705010"}
                  bgColor={"#FFEDC8"}
                  style={{ marginRight: "5px" }}
                />
              )}
            </div>
          </div>
          <Divider />

          <div className={`${containerClass} mt-2`}>
            {props?.isImportedTest && (
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => props?.importTestHandler(testData?.id)}
                    disabled={testData?.isAlreadyImported}
                  />
                }
              />
            )}
            <DataCell title={"Format"} data={testData?.format || "-"} />
            <DataCell title={"Mode"} data={testData?.mode || "-"} />

            <DataCell title={"Start date"}>
              {testData?.mode !== "Offline" ? (
                <div className="d-flex text-xs">
                  {`${getDateFormateDate(testData?.startDate)} at...`}
                  <APopover
                    buttonComponent={(onClick, styles) => (
                      <span onClick={onClick} className="cursor-pointer ml-1">
                        <EyeIcon />
                      </span>
                    )}
                    menuComponent={(closeForm) => (
                      <>
                        <Card className="mb-0 regular-body label-color">
                          <div className="p-2 text-bold">
                            {`${getDateFormateDate(
                              testData?.startDate
                            )} at ${getTimeFormated(
                              testData?.testStartTime || testData.startDate
                            )}`}
                          </div>
                        </Card>
                      </>
                    )}
                    transformOriginVertical="center"
                    transformOriginHorizontal="left"
                  />
                </div>
              ) : (
                getDateFormateDate(testData?.startDate)
              )}
            </DataCell>

            <DataCell title={"End date"}>
              {testData?.mode !== "Offline" ? (
                <div className="d-flex text-xs">
                  {`${getDateFormateDate(testData?.endDate)} at...`}
                  <APopover
                    buttonComponent={(onClick, styles) => (
                      <span onClick={onClick} className="cursor-pointer ml-1">
                        <EyeIcon />
                      </span>
                    )}
                    menuComponent={(closeForm) => (
                      <>
                        <Card className="mb-0 regular-body label-color">
                          <div className="p-2 text-bold">
                            {`${getDateFormateDate(
                              testData?.endDate
                            )} at ${getTimeFormated(
                              testData?.testEndTime || testData.endDate
                            )}`}
                          </div>
                        </Card>
                      </>
                    )}
                    transformOriginVertical="center"
                    transformOriginHorizontal="left"
                  />
                </div>
              ) : (
                getDateFormateDate(testData?.endDate)
              )}
            </DataCell>

            {/* new column added for same day Online/Both tests*/}
            <DataCell
              title={"Start within"}
              data={
                testData?.isStartWithinTimeRequired
                  ? `${testData?.startWithinTimePeriod} h`
                  : "-"
              }
            />

            {/* new column added for same day Online/Both tests*/}
            <DataCell
              title={"Evaluation Date"}
              data={
                testData?.evaluationDate
                  ? `${getDateFormateDate(testData?.evaluationDate)}`
                  : "-"
              }
            />

            <DataCell title={"Result date"}>
              {testData?.isStartWithinTimeRequired ? (
                <div className="d-flex text-xs">
                  {`${getDateFormateDate(testData?.resultDate)} at...`}
                  <APopover
                    buttonComponent={(onClick, styles) => (
                      <span onClick={onClick} className="cursor-pointer ml-1">
                        <EyeIcon />
                      </span>
                    )}
                    menuComponent={(closeForm) => (
                      <>
                        <Card className="mb-0 regular-body label-color">
                          <div className="p-2 text-bold">
                            {`${getDateFormateDate(
                              testData?.resultDate
                            )} at ${getTimeFormated(testData?.resultDate)}`}
                          </div>
                        </Card>
                      </>
                    )}
                    transformOriginVertical="center"
                    transformOriginHorizontal="left"
                  />
                </div>
              ) : (
                getDateFormateDate(testData?.resultDate)
              )}
            </DataCell>

            <DataCell
              title={"Test medium"}
              data={getTestMediumDisplayValue(testData?.testMediumType) || "-"}
            />
            <DataCell title={"Attach test"}>
              <div style={{ display: "flex" }}>
                <Tooltip title={testData?.attachTestShortCode}>
                  <span
                    className={commonStyles.link_button}
                    style={{
                      display: "inline-block",
                      fontSize: "14px",
                      borderBottom: "1px solid #00B0F5",
                      marginRight: "3px",
                      cursor: "default",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "100px",
                    }}
                  >
                    {testData?.attachTestShortCode
                      ? `${testData?.attachTestShortCode}`
                      : `Attach test`}
                  </span>
                </Tooltip>
                {isPastDate(testData?.startDate) ? (
                  <Tooltip title="Cannot edit as test start date has passed">
                    <IconButtonWrapper onClick={() => {}}>
                      <EditIcon
                        className="ml-2"
                        style={{
                          width: "14px",
                          height: "14px",
                          cursor: "pointer",
                        }}
                      />
                    </IconButtonWrapper>
                  </Tooltip>
                ) : (
                  <APopover
                    buttonComponent={(onClick, styles) =>
                      !props?.isImportedTest ? (
                        <IconButtonWrapper onClick={onClick}>
                          <EditIcon
                            className="ml-2"
                            style={{
                              width: "14px",
                              height: "14px",
                              cursor: "pointer",
                            }}
                          />
                        </IconButtonWrapper>
                      ) : (
                        ""
                      )
                    }
                    menuComponent={(closeForm) => (
                      <AttachTestForm
                        closeForm={closeForm}
                        testData={testData}
                        planData={planData}
                        updateAttachTestHandler={updateAttachTestHandler}
                        isTimeTableEvent={false}
                      />
                    )}
                  />
                )}
              </div>
            </DataCell>
            <DataCell title={"Status"}>
              {props?.isImportedTest ? (
                <CustomChip
                  // text={}
                  textColor="#0B442D"
                  bgColor="#BBE2CE"
                >
                  {testData?.active ? "Active" : "Inactive"}
                </CustomChip>
              ) : (
                <span>
                  {testData?.active ? (
                    isPastDate(testData?.startDate) ? (
                      <Tooltip title="Cannot edit as test start date has passed">
                        <ActiveControl onClick={() => {}} />
                      </Tooltip>
                    ) : (
                      <ActiveControl onClick={() => activeInactiveHandler()} />
                    )
                  ) : isPastDate(testData?.startDate) ? (
                    <Tooltip title="Cannot edit as test start date has passed">
                      <InactiveControl onClick={() => {}} />
                    </Tooltip>
                  ) : (
                    <InactiveControl onClick={() => activeInactiveHandler()} />
                  )}
                  <span
                    style={{
                      fontSize: "14px",
                      marginLeft: "4px",
                      color: testData?.active ? "#0F0F0F" : "#757575",
                    }}
                  >
                    {testData?.active ? "ACTIVE" : "INACTIVE"}
                  </span>
                </span>
              )}
            </DataCell>
            <DataCell title={"Actions"}>
              <div className="d-flex align-items-center">
                <span
                  className={commonStyles.link_button}
                  style={{ fontSize: "14px" }}
                  onClick={() =>
                    expandedIndex === index
                      ? setExpandedIndex(-1)
                      : setExpandedIndex(index)
                  }
                >
                  {expandedIndex === index
                    ? `Hide test syllabus`
                    : `View test syllabus`}
                </span>
                {!props?.isImportedTest && (
                  <span>
                    {isPastDate(testData?.resultDate) ? (
                      <Tooltip title="Cannot edit as test result date has passed">
                        <IconButtonWrapper onClick={() => {}}>
                          <EditIcon
                            className="ml-2"
                            style={{
                              width: "14px",
                              height: "14px",
                              cursor: "pointer",
                            }}
                          />
                        </IconButtonWrapper>
                      </Tooltip>
                    ) : (
                      <IconButtonWrapper onClick={() => setIsFormOpen(true)}>
                        <EditIcon
                          className="ml-2"
                          style={{
                            width: "14px",
                            height: "14px",
                            cursor: "pointer",
                          }}
                        />
                      </IconButtonWrapper>
                    )}
                  </span>
                )}
              </div>
            </DataCell>
          </div>
          {expandedIndex === index && (
            <TestSyllabus
              testData={testData}
              // testSyllabus={testSyllabus}
              // setTestSyllabus={setTestSyllabus}
              // isSyllabusFetched={isSyllabusFetched}
              // setIsSyllabusFetched={setIsSyllabusFetched}
            />
          )}
        </CardBody>
      </Card>
      <TestStatusChangeConfirmationDialog
        open={openDialog}
        setOpen={setOpenDialog}
        testData={testData}
        onAgree={updateTestStatusHandler}
      />

      <DeleteConfirmationPopup
        isOpen={openDeleteConfirmDialog.open}
        handleSave={handleDeleteTest}
        handleCloseDialog={() => {
          setOpenDeleteConfirmDialog(closeDeleteDialogValue);
        }}
      />

      {isFormOpen && (
        <TestForm
          planData={planData}
          basicDetails={testBasicDetails}
          academicPlanId={planData?.id}
          testId={testData?.id}
          getTestList={initialiseList}
          open={isFormOpen}
          onClose={() => setIsFormOpen(false)}
          isDisableTestType={!isIncomplete}
        />
      )}
    </>
  );
};

export default TestCard;
